module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    class: ['main-sidebar', _vm.$root.hideSideMenu ? '' : ''],
    attrs: {
      "id": "slider"
    }
  }, [_c('section', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "user-panel1"
  }, [_c('div', {
    staticClass: "image user-header",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('img', {
    staticClass: "user-image center-block roundImage",
    attrs: {
      "src": _vm.logoPath,
      "alt": "User Image"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Account')
      }
    }
  }, [_c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "10px",
      "font-size": "16px",
      "color": "#ffffff"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$root.userFullName))]), _vm._v(" "), (_vm.$root.userCompanyName) ? _c('p', [_vm._v(_vm._s(_vm.$root.userCompanyName))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "user-panel",
    staticStyle: {
      "display": "none"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-left info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$root.userFullName))]), _vm._v(" "), (_vm.$root.user.Connected) ? _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle",
    staticStyle: {
      "color": "green"
    }
  }), _vm._v(" online")]) : _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle",
    staticStyle: {
      "color": "red"
    }
  }), _vm._v(" offline")])]), _vm._v(" "), (_vm.$root.device.isMobile) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "fa fa-sign-out text-red btn btn-flat",
    staticStyle: {
      "font-size": "20px"
    },
    on: {
      "click": _vm.$root.logout
    }
  })]) : _vm._e()]), _vm._v(" "), _c('form', {
    staticClass: "sidebar-form",
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtSearch),
      expression: "txtSearch"
    }],
    staticClass: "form-control",
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "type": "text",
      "name": "q",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.txtSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtSearch = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, [_vm._l((_vm.$root.slideTopItems), function(item, index) {
    return _c('va-slide-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.show),
        expression: "item.show"
      }],
      key: index,
      attrs: {
        "data": item,
        "type": item.type,
        "isHeader": item.isHeader,
        "isLink": item.isLink,
        "icon": item.icon,
        "FullName": _vm.$root.shortText(item.FullName, 20),
        "title": item.FullName,
        "badge": item.badge,
        "items": item.items,
        "router": item.router,
        "link": item.link
      },
      nativeOn: {
        "click": function($event) {
          return _vm.slideItemClick(item)
        }
      }
    })
  }), _vm._v(" "), (_vm.$root.isDealer || _vm.$root.isDealerAssistance) ? _c('li', {
    attrs: {
      "title": "Download LAN Installer"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$root.installerLinks.LanInstaller,
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.lanInstalledClicked()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Download LAN Installer")])])]) : _vm._e(), _vm._v(" "), (_vm.$root.isDealer || _vm.$root.isDealerAssistance) ? _c('li', {
    attrs: {
      "title": "Download USB Installer"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$root.installerLinks.UsbInstaller,
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.usbInstalledClicked()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Download USB Installer")])])]) : _vm._e()], 2), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "data-widget": "tree"
    }
  }, _vm._l((_vm.filteredItems), function(item, index) {
    return _c('va-slide-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.show),
        expression: "item.show"
      }],
      key: index,
      attrs: {
        "data": item,
        "type": item.type,
        "isHeader": item.isHeader,
        "isLink": item.isLink,
        "icon": item.icon,
        "FullName": _vm.$root.shortText(item.FullName, 20),
        "title": item.FullName,
        "badge": item.badge,
        "items": item.items,
        "router": item.router,
        "link": item.link
      },
      nativeOn: {
        "click": function($event) {
          return _vm.slideItemClick(item)
        }
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left image"
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": "https://image.flaticon.com/icons/png/512/149/149071.png",
      "alt": "User Image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('div', {
    staticClass: "btn btn-flat",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-387458df!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Slider.vue
// module id = 693
// module chunks = 0